// 结果完善
<template>
    <div class="return">
         <div class="box">

            <div class="reason " :class="selectValue ? '' : 'line_bottom'">
                <div class="left">处理结果</div>
                <div class="right" @click="backReasons">
                    <span v-if="!selectValue || selectValue === ''">请选择</span>
                    <span v-else class="right_item">{{ selectValue }}</span>
                    <img src="../../../../assets/image/ic_lb_jt@3x.png"/>
                </div>
            </div>

            <!-- 调解成功 -->
            <div class="reason_box" v-if="selectValue">
                <!-- 调解成功 / 自行和解 / 启用质保金赔偿 -->
                <!-- <div class="reason_box_title line_bottom" v-if="selectValue !== '调解失败'">
                    <div class="reason_box_title_left">赔偿金额</div>
                    <div class="reason_box_title_right">
                        <input type="text" placeholder="请输入赔偿金额" @input="onInputMoney" v-model.trim="inputMoney">
                        <span v-if="inputMoney" class="text_right">元</span>
                    </div>
                </div> -->

                <div class="reason_box_title line_bottom" v-if="selectValue !== '调解失败'">
                    <div class="reason_box_title_left">退货退款</div>
                    <div class="reason_box_title_right">
                        <input type="text" placeholder="请填写至少一项赔偿金额" @input="onInputMoney" v-model.trim="inputMoney">
                        <span v-if="inputMoney" class="text_right">元</span>
                    </div>
                </div>
                <div class="reason_box_title line_bottom" v-if="selectValue !== '调解失败'">
                    <div class="reason_box_title_left">服务金赔偿</div>
                    <div class="reason_box_title_right">
                        <input type="text" placeholder="请填写至少一项赔偿金额" @input="onrefundMoney" v-model.trim="refundMoney">
                        <span v-if="refundMoney" class="text_right">元</span>
                    </div>
                </div>

                <!-- 调解成功 -->
                <div class="reason_box_title line_bottom" v-if="selectValue === '调解成功'">
                    <div class="reason_box_title_left">履行时间</div>
                    <div class="reason_box_title_right" @click="performTime">
                        <span v-if="!performDate || performDate === ''">请选择</span>
                        <span v-else class="reason_box_title_right_span">{{ performDate }}</span>
                        <img src="../../../../assets/image/ic_lb_jt@3x.png" alt="">
                    </div>
                </div>

                <!-- 调解成功 -->
                <div class="reason_box_title line_bottom" v-if="selectValue === '调解成功'">
                    <div class="reason_box_title_left">履行地点</div>
                    <div class="reason_box_title_right">
                        <input type="text" placeholder="请输入履行地点" v-model="inputEary">
                    </div>
                </div>

                <!-- 调解成功 / 启用保质金赔偿    -->
                <div class="reson_content" v-if="(selectValue === '调解成功' || selectValue === '启用质保金赔偿')">
                    <div class="r_txt">事实经过</div>
                    <div class="r_content">
                        <!-- <textarea
                            class="markRemackBox"
                            v-model.trim="realSituation"
                            @input="onInputOne"
                            placeholder="请详细描述事实经过"
                        ></textarea> -->
                        <van-field
                            class="markRemackBox"
                            v-model.trim="realSituation"
                            autosize
                            type="textarea"
                            maxlength="300"
                            placeholder="请详细描述事实经过"
                        />
                        <span class="total_text">{{currentTotal}}/300</span>
                    </div>
                </div> 

                <!-- 调解成功 / 调解失败  --》 调解备注   -->
                <!-- 自行和解 / 启用保质金赔偿 --》 和解备注 -->
                <div class="reson_content">
                    <div class="r_txt">{{ (selectValue === '调解成功' || selectValue === '调解失败') ? '调解备注' : '和解备注' }}</div>
                    <div class="r_content">
                        <!-- <textarea
                            class="markRemackBox"
                            v-model.trim="message"
                            @input="onInput"
                            :placeholder="(selectValue === '调解成功' || selectValue === '调解失败') ? '请详细描述调解备注' : '请详细描述和解备注'"
                        ></textarea> -->
                        <van-field
                            class="markRemackBox"
                            v-model.trim="message"
                            autosize
                            type="textarea"
                            maxlength="300"
                            :placeholder="(selectValue === '调解成功' || selectValue === '调解失败') ? '请详细描述调解备注' : '请详细描述和解备注'"
                        />
                        <span class="total_text">{{currentTotal1}}/300</span>
                    </div>
                </div> 
            </div>

            <div class="reason line_bottom">
                <div class="left">结案时间</div>
                <div class="right" @click="backTime">
                        <span v-if="!caseTime || caseTime === ''">请选择</span>
                        <span v-else class="right_item">{{ caseTime }}</span>
                        <img src="../../../../assets/image/ic_lb_jt@3x.png"/>
                </div>
            </div>

            <div class="upload_img">
                <div class="markFuil">
                    <upload :imgUrl="imgUrl" :isShowTitle="true" :fileSource='1' :fileBizType='6'></upload>
                </div>
            </div>

            <div class="upload_file">
                <div class="upload_tit">相关材料</div>

                <!-- <div class="file_item" v-for="(item,index) in files" :key="item.id">
                    <div class="file_msg">
                    <img src="@/assets/appraise/ic_pdf.png" alt />
                    <p class="file_name">
                        <span>{{item.fileName}}.{{item.fileType}}</span>
                    </p>
                    </div>
                    <div class="delImg" @click="del(index)">
                    <img src="@/assets/appraise/delete.png" alt />
                    </div> -->
                    <!-- <div class="file_size">{{item.fileSize}}</div> -->
                <!-- </div> -->

                <materiascience :caseList="files" @deleteFiel="delFile"></materiascience>
                <addFile
                    ref="resetfilesbtn"
                    @fields="addbtnClick"
                    :isShowSpan="false"
                    :isGoAndroidandIOS="true"
                    :needEmit="true"
                ></addFile>
            </div>

            <div class="submit_btn">
                <div class="submit_item" :class="{'active': isShowBtn}" @click="submitBtn">
                    提交
                </div>
            </div>
         </div>

         <div class="complaint_from_wrap" v-if="isShowDetail">
            <div class="complaint_no"></div>
            <div class="complaint_from">
                <div class="complaint_title line_bottom">
                    <div class="complaint_title_left">原投诉单信息</div>
                    <div class="complaint_title_right" @click="seeDetail">
                        <span>查看详情</span>
                        <img src="../../../../assets/image/ic_lb_jt@3x.png" alt="">
                    </div>
                </div>
                <div class="complaint_nav">
                    <div class="complaint_nav_item">
                        <div class="complaint_nav_title">投诉对象: </div>
                        <div class="complaint_nav_name">{{ dataObj.complainObject }}</div>
                    </div>
                    <div class="complaint_nav_item">
                        <div class="complaint_nav_title">投诉人: </div>
                        <div class="complaint_nav_name">{{ dataObj.complainUser }}</div>
                    </div>
                    <div class="complaint_nav_item">
                        <div class="complaint_nav_title">投诉时间: </div>
                        <div class="complaint_nav_name">{{ dataObj.complainTime }}</div>
                    </div>
                    <div class="complaint_nav_item">
                        <div class="complaint_nav_title">投诉单号: </div>
                        <div class="complaint_nav_name">{{ dataObj.mainComplainNumber }}</div>
                    </div>
                </div>
            </div>
         </div>

 
         <!-- 处理结果 -->
         <common-picker ref="commonPicker2" :typeList="list" :cols="colsDetail" @getTypeValue="typeListDetail"></common-picker>

        <!-- 结案时间 -->
        <van-popup
            class="popBox"
            v-model="isShowTimePicker"
            position="bottom"
            :style="{ height: '40%' }"
        >
            <time-PickerFB @getDate="getDate" @cancelDatePick="cancelDatePick" :minDate="minDate"/>
        </van-popup>

        <!-- 履行时间 -->
        <van-popup
            class="popBox"
            v-model="isShowTimePickerTime"
            position="bottom"
            :style="{ height: '40%' }"
        >
            <time-PickerFB @getDate="getDateTiem" @cancelDatePick="cancelDatePickTime" :minDate="minDate"/>
        </van-popup>
    </div>
</template>
<script>
import commonPicker from '../../../../components/base/commonPicker';
import TimePickerFB from '../../component/TimePickerFB'
import rangTime from '../../../../components/rangTime1';
import { timeType1 } from '../../../../utils/configJson';
// import Upload from '../../component/Upload'; 
import Upload from '@/components/uploadCopy';
import addFile from '../../component/addFile';
import api from '../../../../service/modules/complaintApis';
import materiascience from '../../component/materialScience_delete';
 import util from '@/utils/common';

export default {
    components: {
        commonPicker,
        rangTime,
        addFile,
        Upload,
        TimePickerFB,
        materiascience
    },
    data () {
        return {
            minDate:'',
            isShow: this.$route.query.isShow,
            isShowDetail: true,
            dataObj: {},
            // isShowBtn: false, // 是否可以点击按钮
            isShowTimePicker: false, // 是否展开结案时间选择器
            isShowTimePickerTime: false, // 履行时间选择器
            selectValue: '', // 
            performDate: '', // 履行时间
            caseTime: '', // 结案时间
            colsDetail: 1,
            detailList1: [
                [
                    {
                        text: '自行和解',
                        value: '自行和解'
                    },
                    {
                        text: '调解失败',
                        value: '调解失败'
                    }
                ]
            ],
            list:[],
            detailList: [
                [
                    {
                        text: '自行和解',
                        value: '自行和解'
                    },
                    {
                        text: '调解成功',
                        value: '调解成功'
                    },
                    {
                        text: '调解失败',
                        value: '调解失败'
                    },
                    {
                        text: '启用质保金赔偿',
                        value: '启用质保金赔偿'
                    }
                ]
            ],
            inputMoney: '', // 赔偿金额
            refundMoney: '', //  服务金赔偿
            inputEary: '', // 履行地点
            message: '', // 调解备注
            realSituation: '', // 事实经过
            // 上传绑定的IMG数组
            imgUrl: [],

            /** 文件 **/
            files: [],
            filesList: [],
            delIndex: {}, // 存放删除的索引
            isShowTipDialog: false, // 没有选择类型的提示
            tipDialogContent: "", // 提示文字
            subId: this.$route.query.subId,
            id: this.$route.query.id,
            mainComplainNumber: this.$route.query.mainComplainNumber,
            complainNumber: this.$route.query.complainNumber,
            itemList: util.getJsonLocal('item'),
            userInfo: this.$store.state.complaint.userInfo || util.getJsonLocal('userInfoComplaint'), // 用户信息
        }
    },
    computed: {
        isShowBtn () {
            if (this.selectValue === '调解成功' && this.caseTime && (this.inputMoney >=0  || this.refundMoney >= 0) && this.performDate && this.inputEary && this.message && this.realSituation) {
                return true;
            } else if (this.selectValue === '调解失败' && this.caseTime && this.message) { 
                return true;
            } else if (this.selectValue === '自行和解' && this.caseTime && (this.inputMoney >= 0 || this.refundMoney >= 0) && this.message) {
                return true;
            } else if (this.selectValue === '启用质保金赔偿' && this.caseTime && (this.inputMoney >= 0 || this.refundMoney >= 0) && this.message && this.realSituation) {
                return true;
            } else {
                return false;
            }
        },
        currentTotal(){
            return this.realSituation.length;
        },
        currentTotal1(){
            return this.message.length;
        },
    },
    watch: {
        'selectValue'(val, oldValue) {
            if (val != oldValue) {
                this.inputMoney = '';
                this.refundMoney = '';
                this.performDate = '';
                this.inputEary = '';
                this.message = '';
                this.realSituation = '';
            }
        },
    },
    created () {
        if (this.isShow === 'false') {
            this.isShowDetail = false;
        }
        this.getAutoWriteInfo();   
        this.minDate=new Date(JSON.parse(localStorage.getItem('info')).complainTime.replace(/-/g,'/'));
        // this.minDate=new Date(JSON.parse(localStorage.getItem('info')));
  
    },  
    mounted () {
        this.$on('fileUploadData', val => {//
        console.log(val);
            this.imgUrl = val
        })
    },
    methods: {
        /**
         * 
         *      原投诉单信息    
         */
        getAutoWriteInfo () {
            api.return.getAutoWriteInfo({ mainComplainNumber: this.mainComplainNumber || this.itemList.mainComplainNumber }).then(res => {
                if (res.ret === 0) {
                    // alert(1)
                    this.dataObj = res.data;
                    // this.minDate=new Date(res.data.complainTime);
                    // this.minDate=new Date(2020, 8, 23);
                    // console.log(this.minDate,'minDate');
                    // alert(this.minDate);
                }
            })
        },

        /** 清楚输入的空格 */
        // onInput () {
        //     this.message = this.message.replace(" ","");
        // },
        // onInputOne () {
        //     this.realSituation = this.realSituation.replace(" ","");
        // },
        onInputMoney () {
            // let reg = /^(([0-9][0-9]*)|(([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2})))$/;
            let reg = /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/;
            if (!reg.test(this.inputMoney)) {
                this.inputMoney = '';
                this.$Toast('请正确填写金额!');
                return;
            } 
            // else if (!(this.inputMoney > 0)) {
            //     this.$Toast('填写金额需大于0!');
            //     return;
            // }
        },
        onrefundMoney() {
            // let reg = /^(([0-9][0-9]*)|(([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2})))$/;
            let reg = /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/;
            if (!reg.test(this.refundMoney)) {
                this.refundMoney = '';
                this.$Toast('请正确填写金额!');
                return;
            } 
            // else if (!(this.refundMoney > 0)) {
            //     this.$Toast('填写金额需大于0!');
            //     return;
            // }
        },
        /**
         * @description: 删除，调起二次确认弹窗
         */
        del(index) {
            // this.dialogTitle = "是否确定删除";
            // this.dialogContent = "";
            // this.cancelBtn = "取消";
            // this.confirmBtn = "删除";
            // this.showDialog = true;
            // this.saveAndDel = "del"; // 保存还是删除
            // this.delIndex = index;
            // if (this.$refs.resetfilesbtn) {
            //     this.$refs.resetfilesbtn.resetFile();
            // }
        },

        // 履行时间
        performTime () {
            this.isShowTimePickerTime = true;
        },

        // 附件
        addbtnClick (file, cos) {
            this.files.push(file[0]);
            let path = 'https://' + cos.bucket + '.cos.' + cos.region + '.myqcloud.com/' + file[0].filePath;
            this.filesList.push(path);
        },

        /** 删除文件 **/
        delFile(index) {
            this.files.splice(index, 1);
            this.filesList.splice(index, 1);
        },

        // 唤起处理结果弹窗
        backReasons () {
            if(this.userInfo.userInfo.orgType.indexOf('company')>-1){
                this.list=this.detailList1;
            }else{
                this.list=this.detailList;
            }
            this.$refs.commonPicker2.showPicker();
        },

        // 唤起时间弹窗
        backTime () {
            this.isShowTimePicker = true;
        },

        // 切换数据
        typeListDetail (val) {
            this.selectValue = val[0].value;
        },

        getDate (val) {
            this.caseTime = val;
            this.isShowTimePicker = false;
        },
        // 关闭时间选择器
        cancelDatePick (val) {
            this.isShowTimePicker = val;
        },

        // 履行时间
        getDateTiem (val) {
            this.performDate = val;
            this.isShowTimePickerTime = false;
        },
        cancelDatePickTime (val) {
            this.isShowTimePickerTime = val;
        },

        seeDetail () {
            this.$router.replace({
                path: '/complaint/detailList/complaintSheet',
                query: {

                }
            })
        },

        submitBtn () {

            // if (((this.selectValue === '调解成功' && (this.inputMoney || this.refundMoney) && this.performDate && this.inputEary && this.realSituation) || this.selectValue === '调解失败' || (this.selectValue === '自行和解' && (this.inputMoney || this.refundMoney)) || (this.selectValue === '启用质保金赔偿' && (this.inputMoney || this.refundMoney) && this.realSituation)) && this.caseTime && this.message) {
                
            //     if (this.message.length < 20) {
            //         if (this.selectValue === '调解成功' || this.selectValue === '调解失败') {
            //             this.$Toast('调解备注字数为20-200字');
            //         } else {
            //             this.$Toast('和解备注字数为20-200字');
            //         }
            //         return;
            //     }
            //     if (this.realSituation === this.message) {
            //         this.$Toast('必须填投诉办结后的结果');
            //         return;
            //     }
                switch (this.selectValue) {
                    case '调解成功':
                        var reg = /^([0-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/;
                        if (!reg.test(this.refundMoney)&&!reg.test(this.inputMoney)) {
                            // this.refundMoney = '';
                            this.$Toast('请正确填写金额!');
                            return;
                        }
                        if(!this.performDate){
                            this.$Toast('请选择履行时间');
                            return;
                        }
                        if(!this.inputEary){
                            this.$Toast('请填写履行地点');
                            return;
                        }
                        if (this.realSituation.length < 20) {
                            this.$Toast('事实经过字数为20-300字');
                            return;
                        }
                        if (this.message.length < 20) {
                            this.$Toast('调解备注字数为20-300字');
                            return;
                        }
                        if(!this.caseTime){
                            this.$Toast('请选择结案时间');
                            return;
                        }
                        this.getSuccessSupplement()
                        break;
                    case '调解失败':
                        if (this.message.length < 20) {
                            this.$Toast('调解备注字数为20-300字');
                            return;
                        }
                        if(!this.caseTime){
                            this.$Toast('请选择结案时间');
                            return;
                        }
                        this.getFailSupplement();
                        break;
                    case '自行和解':
                        var reg = /^([0-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/;
                        if (!reg.test(this.refundMoney)&&!reg.test(this.inputMoney)) {
                            // this.refundMoney = '';
                            this.$Toast('请正确填写金额!');
                            return;
                        }if (this.message.length < 20) {
                            this.$Toast('和解备注字数为20-300字');
                            return;
                        }
                        if(!this.caseTime){
                            this.$Toast('请选择结案时间');
                            return;
                        }
                        this.getSelfSupplement();
                        break;
                    case '启用质保金赔偿':
                         var reg = /^([0-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/;
                        if (!reg.test(this.refundMoney)&&!reg.test(this.inputMoney)) {
                            // this.refundMoney = '';
                            this.$Toast('请正确填写金额!');
                            return;
                        }
                        
                        if (this.realSituation.length < 20) {
                            this.$Toast('事实经过字数为20-300字');
                            return;
                        }
                        if (this.message.length < 20) {
                            this.$Toast('和解备注字数为20-300字');
                            return;
                        }
                        if(!this.caseTime){
                            this.$Toast('请选择结案时间');
                            return;
                        }
                        this.getWarrantySupplement();
                        break;
                }
            // }
        },
        /**
         *      自行和解
         */
        getSelfSupplement () {  
            let params = {
                supplementType:'1',
                mainComplainNumber: this.mainComplainNumber || this.itemList.mainComplainNumber,
                complainSubId: this.subId || this.itemList.subId,
                complainNumber: this.complainNumber || this.itemList.complainNumber,
                // amount: this.inputMoney,
                // refundAmount: this.refundMoney,
                refundAmount: this.inputMoney,
                amount: this.refundMoney,
                complainEndTime: this.caseTime,
                remark: this.message,
                files: this.filesList,
                images: this.imgUrl
            }
            api.return.selfSupplement(params).then(res => {
                if (res.ret === 0) {
                    if (this.$route.query.isShow) {
                        this.$router.go(-1);
                    } else {
                        yyn.invokeJSB('closeWindow');
                        this.$Toast({
                            message: '处理成功',
                            icon: 'passed'
                        });
                    }
            //         // this.$router.push('/index');
                }
            })
        },
        /**
         *      调解成功
         */
        getSuccessSupplement () {
            let params = {
                supplementType:'2',
                mainComplainNumber: this.mainComplainNumber  || this.itemList.mainComplainNumber, // 主单号 
                complainSubId: this.subId || this.itemList.subId,      // sub主键ID
                complainNumber: this.complainNumber || this.itemList.complainNumber,     // 子单号
                complainEndTime: this.caseTime, // 结案时间
                agreement: this.message,            // 达成的协议 == 备注
                realSituation: this.realSituation, // 事实经过
                refundAmount: this.inputMoney,
                amount: this.refundMoney,
                fulfillPlace: this.inputEary, // 履行地点
                fulfillTime: this.performDate,// 履行时间
                // remark: this.message,            // 备注
                files: this.filesList,            // 文件
                images: this.imgUrl           // 图片
            }
            api.return.successSupplement(params).then(res => {
                if (res.ret === 0) {
                     if (this.$route.query.isShow) {
                        this.$router.go(-1);
                    } else {
                        yyn.invokeJSB('closeWindow');
                        this.$Toast({
                            message: '处理成功',
                            icon: 'passed'
                        });
                    }
                    // this.$router.push('/index');
                }
            })
        },
        /**
         *      调解失败
         */
        getFailSupplement () {
            let params = {
                supplementType:'3',
                mainComplainNumber: this.mainComplainNumber || this.itemList.mainComplainNumber,
                complainSubId: this.subId || this.itemList.subId,
                complainNumber: this.complainNumber || this.itemList.complainNumber,
                complainEndTime: this.caseTime,
                remark: this.message,
                files: this.filesList,
                images: this.imgUrl,
                realSituation: ''
            }
            api.return.failSupplement(params).then(res => {
                if (res.ret === 0) {
                     if (this.$route.query.isShow) {
                        this.$router.go(-1);
                    } else {
                        yyn.invokeJSB('closeWindow');
                        this.$Toast({
                            message: '处理成功',
                            icon: 'passed'
                        });
                    }
                    // this.$router.push('/index');
                }
            })
        },
        /**
         *      启用质保金
         */
        getWarrantySupplement () {
            let params = {
                supplementType:'4',
                mainComplainNumber: this.mainComplainNumber || this.itemList.mainComplainNumber,
                complainSubId: this.subId || this.itemList.subId,
                complainNumber: this.complainNumber || this.itemList.complainNumber,
                refundAmount: this.inputMoney,
                amount: this.refundMoney,
                complainEndTime: this.caseTime,
                realSituation: this.realSituation, // 事实经过
                remark: this.message, 
                files: this.filesList,
                images: this.imgUrl
            }
            api.return.warrantySupplement(params).then(res => {
                if (res.ret === 0) {
                     if (this.$route.query.isShow) {
                        this.$router.go(-1);
                    } else {
                        yyn.invokeJSB('closeWindow');
                        this.$Toast({
                            message: '处理成功',
                            icon: 'passed'
                        });
                    }
                    // this.$router.push('/index');
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.return{
    width:100%;
    height:100%;
    .box{
        width:100%;
        // height:100%;
        padding:0 12px;
        box-sizing: border-box;
        .item{
            width:100%;
            display: flex;
            flex-direction: row;
            align-content: center;
            align-items:flex-start;
            font-size:14px;
            margin-top:16px;
            .left{
                color:#999;
                width:60px;
            }
            .right{
                color:#333;
                flex:1;
                margin-left:27px;
            }
            .right1{
                line-height: 1.3em;
            }
        }
        .reason{
            width:100%;
            padding:16px 0;
            display: flex;
            flex-direction: row;
            align-content: center;
            justify-content: space-between;
            .left{
                color:#666666;
                font-size:14px;
            }
            .right{
                display: flex;
                flex-direction: row;
                align-content: center;
                justify-content: space-between;
                span{
                    font-size:14px;
                    color:#CCCCCC;
                }
                img{
                    margin-top: 1px;
                    width: 12px;
                    height: 12px;
                    display: inline-block;
                }
                .right_item {
                    color:#333;
                }
            }
        }

        .reason_box {
            background: #FFFFFF;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
            border-radius: 3px;
            box-sizing: border-box;
            margin: 8px 0;
            .reason_box_title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 16px;
                .reason_box_title_left {
                    font-size: 14px;
                    color: #999;
                    font-weight: 400;
                }
                .reason_box_title_right {
                    color: #ccc;
                    font-size: 14px;
                    font-weight: 400;
                    display: flex;
                    align-items: center;
                    input{
                        text-align: right;
                        color: #333;
                        font-weight: 400;
                        width:200px;
                        padding-right:6px;
                        box-sizing: border-box;
                    }
                    .text_right {
                        color: #333;
                        margin-left: 6px;
                    }
                    // 修改input默认提示颜色
                    input::placeholder{
                        color:#ccc;
                    }
                    img{
                        margin-left: 4px;
                        display: inline-block;
                        width: 10px;
                        height: 12px;
                    }
                    .reason_box_title_right_span {
                        color: #333;
                    }
                }
            }
            .reson_content{
                padding: 0 16px 16px 16px;
                width:100%;
                .r_txt{
                    padding-top:16px;
                    font-size:14px;
                    color:#999;
                    font-weight: 400;
                }
                .r_content{
                    width:100%;
                    margin-top:12px;
                    position: relative;
                    textarea{
                        width:100%;
                        height:100%;
                        border:0;
                        outline: none;
                        background-color: #F5F5F5;
                        border-radius: 3px;
                        font-size:14px;
                        padding:14px 12px 0 12px;
                        box-sizing: border-box;
                    }
                    .markRemackBox{
                        width:100%;
                        border:0;
                        padding:16px 16px 32px 16px;
                        box-sizing: border-box;
                        outline: none;
                        background-color: #F9F9F9;
                        min-height:104px;
                        border-radius: 3px;
                        font-size:14px;
                        font-weight: 400;
                        color: #333;
                        line-height: 18px;
                    }
                    .total_text{
                        position: absolute;
                        right:10px;
                        bottom:10px;
                        font-size:14px;
                        color:rgba(0,0,0,.4)
                    }
                }
            }
        }

        .upload_img {
            // height: 100%;
            // margin: 0 12px;
            .markUploadTitle{
                font-size: 14px;
                margin-top: 20px;
                height: 50px;
            }
            .markFuil{

                margin-top: 10px;
            }
        }
        .upload_file {
            padding-bottom: 24px;
            background-color: #fff;
            .upload_tit {
                padding: 16px 0;
                font-size: 14px;
                color: #666;
            }
        }

        .submit_btn {
            width: 100%;
            height: 50px;
            border-radius: 3px;
            margin-bottom: 24px;
            .submit_item {
                background: #36B374;
                height: 100%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                font-size: 16px;
                font-weight: 600;
                color: #fff;
                opacity: .5;
            }
            .active {
                background:rgba(54,179,116,1);
                opacity: 1;
            }
        }
    }

    .complaint_from_wrap {
        background: #FBFBFB;
        .complaint_no {
            height: 16px;
        }
    }

    .complaint_from {
        margin: 0 12px 16px 12px;
        box-sizing: border-box;

        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
        border-radius: 3px;
        border: 1px solid #fff;
        background: #fff;
        .complaint_title {
            height: 54px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 16px;
            .complaint_title_left {
                color: #2A2A2A;
                font-size: 14px;
                font-weight: 600;
            }
            .complaint_title_right {
                color: #666;
                font-size: 12px;
                font-weight: 400;
                img{
                    margin-right: 4px;
                    display: inline-block;
                    width: 12px;
                    height: 10px;
                }
            }
        }
        .complaint_nav {
            padding: 0 16px;
            .complaint_nav_item {
                display: flex;
                flex-direction: row;
                align-content: center;
                align-items:flex-start;
                font-size:14px;
                margin-top:16px;
                .complaint_nav_title {
                    color:#666;
                    width: 60px;
                    font-size: 12px;
                    font-weight: 400;
                }
                .complaint_nav_name {
                    color: #666;
                    font-weight: 400;
                    font-size: 12px;
                    margin-left: 4px;
                }
            }
            .complaint_nav_item:last-child {
                margin-bottom: 24px;
            }
        }
    }
}

</style>